import styled from 'styled-components';
import { CssRule } from '../../../themes/architecture/css-helpers/css-rule';

export const GameItemImgWrapperBox = styled.div`
    // cgp-game-item-img-wrapper
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: 12rem;
    flex-shrink: 0;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 11.4rem;
        ${CssRule.For.iPhoneVer5.build()} {
            width: 6.5rem;
            background-position: center center;
        }
    }

    // cgp-themes-icons-placeholder-game
    background-image: url(${({theme}) => '"' + theme.images.gameIconPlaceHolder + '"'});
    background-size: contain;
    background-repeat: no-repeat;
`;
